import { safeRedirect } from "../utils/urlValidation";

export const handleRedirect = () => {
  localStorage.setItem("parentGroupId", "false");
  const redirectUrl = `${document.location.origin}/callback/`;
  const cognitoUrl = new URL(
    process.env.BASE_COGNITO_LOGIN_URL ||
      "https://actuate-settings.auth.us-west-2.amazoncognito.com/login"
  );
  cognitoUrl.searchParams.append(
    "client_id",
    process.env.COGNITO_CLIENT_ID || "2qbaet284cs7p5oq9ppg4llj1n"
  );
  cognitoUrl.searchParams.append("response_type", "code");
  cognitoUrl.searchParams.append(
    "scope",
    "email openid phone profile aws.cognito.signin.user.admin"
  );
  cognitoUrl.searchParams.append("redirect_uri", redirectUrl);
  const url = cognitoUrl.toString();

  // Use safe redirect with allowed AWS Cognito domain
  safeRedirect(url, ["amazoncognito.com", "actuateui.eu"], "/callback/");

  // Only store the Cognito URL if there isn't already a redirect URL stored
  // (This preserves the original redirect URL set by RequireAuth)
  if (!localStorage.getItem("redirectURL")) {
    localStorage.setItem("redirectURL", url);
  }
};

export const Login = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const error = urlParams.get("error");

  return (
    <div className="flex items-center justify-center font-black">
      <div className="absolute top-8 font-mulish text-xl">
        {error === "failed"
          ? "Login failed. Please try again."
          : "For security reasons you have been logged out."}
      </div>
      <div className="absolute font-mulish top-20 text-xl">
        {error === "failed"
          ? "Click below to try logging in again."
          : "Please click below to log back in."}
      </div>
      <button
        className="shadow-button bg-actuate-orange rounded font-mulish text-white text-base	p-1.5 absolute top-36"
        onClick={handleRedirect}
      >
        {error === "failed" ? "Try Again" : "Login"}
      </button>
    </div>
  );
};
